export enum LOCALSTORAGE_KEYS {
    ACCESS_TOKEN = 'access_token'
}
